module.exports = __webpack_public_path__ + "img/Human_symbol_6.2ca61153.png";